// --- BrokerMaterialsTab.jsx ---
import { useState } from 'react';
import BrokerMaterialEditModal from './editModals/BrokerMaterialEditModal';

function BrokerMaterialsTab({ materials = [], brokerId, onUpdated, canEditBrokers }) {
  const [showModal, setShowModal] = useState(false);

  // Group materials by type
  const groupedMaterials = materials.reduce((acc, material) => {
    const type = material.material_type;
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(material);
    return acc;
  }, {});

  const renderMaterialItem = (material, index, type) => {
    if (type === 'Product') {
      return (
        <li key={`${type}-${index}`} className="list-group-item">
          {index + 1}. {material.material_id.productName} ({material.material_id.productCode})
        </li>
      );
    } else if (type === 'PackingMaterial') {
      return (
        <li key={`${type}-${index}`} className="list-group-item">
          {index + 1}. {material.material_id.name} ({material.material_id.alias})
        </li>
      );
    }
    return null;
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Materials</h5>
        {canEditBrokers && (
          <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowModal(true)}>
            <i className="fa fa-edit me-1"></i> Edit Materials
          </button>
        )}
      </div>

      {materials.length === 0 ? (
        <p className="text-muted">No materials listed.</p>
      ) : (
        <div>
          {/* Products Section */}
          {groupedMaterials.Product && groupedMaterials.Product.length > 0 && (
            <div className="mb-4">
              <h6 className="text-primary mb-2">
                <i className="fa fa-cube me-2"></i>Products ({groupedMaterials.Product.length})
              </h6>
              <ul className="list-group">
                {groupedMaterials.Product.map((material, index) =>
                  renderMaterialItem(material, index, 'Product')
                )}
              </ul>
            </div>
          )}

          {/* Packaging Materials Section */}
          {groupedMaterials.PackingMaterial && groupedMaterials.PackingMaterial.length > 0 && (
            <div className="mb-4">
              <h6 className="text-success mb-2">
                <i className="fa fa-archive me-2"></i>Packaging Materials ({groupedMaterials.PackingMaterial.length})
              </h6>
              <ul className="list-group">
                {groupedMaterials.PackingMaterial.map((material, index) =>
                  renderMaterialItem(material, index, 'PackingMaterial')
                )}
              </ul>
            </div>
          )}
        </div>
      )}
      {canEditBrokers && (
        <BrokerMaterialEditModal show={showModal} onHide={() => setShowModal(false)} brokerId={brokerId} materials={materials} onUpdated={onUpdated} />
      )}
    </div>
  );
}

export default BrokerMaterialsTab;
